import { SITE_CONFIG } from '../config/site-config';

/** A setting counts as configured when it is non-empty and not the "#" placeholder. */
export const isConfigured = (value: string | null | undefined): value is string => Boolean(value) && value !== '#';

/** Internal link for the active routing mode: `/platform` in production, `#/platform` in the preview. */
export const routeHref = (path: string): string => (SITE_CONFIG.ROUTING === 'path' ? path : `#${path}`);

export const mailto = (address: string, subject?: string): string =>
  `mailto:${address}${subject ? `?subject=${encodeURIComponent(subject)}` : ''}`;

export const salesMailto = (): string => mailto(SITE_CONFIG.SALES_EMAIL);

export const EXTERNAL_LINK_ATTRS = 'target="_blank" rel="noopener"';

export const NEW_TAB_NOTE = '<span class="sr-only"> (opens in a new tab)</span>';
